import type { SxProps, Theme } from '@mui/material/styles';

type SxInput = SxProps<Theme> | false | null | undefined;

export const mergeSx = (...inputs: SxInput[]): SxProps<Theme> =>
	inputs.flatMap(item => (item ? (Array.isArray(item) ? item : [item]) : []));
